<app-aviso-de-actualizacion />
<app-ayuda />
<div class="app-container" [class.app-container-bare]="!showChrome()" [class.app-container-documento]="enDocumento()">
    @if (showChrome()) {
    <app-sidebar class="app-sidebar" />
    }

    <div class="app-content-wrapper">
        @if (showChrome()) {
        <app-aviso-del-demo />
        <app-connection-banner />
        }
        <main class="app-main">
            <router-outlet />
        </main>
    </div>
</div>
